<app-d-form-group [autoReset]="true" [formArray]="otpVerificationForm" type="modalForm" (submit)="onVerifyOtp($event)"></app-d-form-group>
